import { render, staticRenderFns } from "./zhenTi.vue?vue&type=template&id=bb0a6d9c&scoped=true&"
import script from "./zhenTi.vue?vue&type=script&lang=js&"
export * from "./zhenTi.vue?vue&type=script&lang=js&"
import style0 from "./zhenTi.vue?vue&type=style&index=0&id=bb0a6d9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0a6d9c",
  null
  
)

export default component.exports